/* Окно общего доступа: список участников и форма приглашения под ним. */

.body {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
  min-width: min(420px, 78vw);
}

.lead,
.muted,
.hint {
  margin: 0;
  color: var(--text-3);
  font-size: var(--fs-sm);
  line-height: 1.4;
}

.list {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
}

/* Имя тянется, роль и кнопка стоят своими колонками — строки не разъезжаются
   от длины адреса. */
.member {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: var(--sp-4);
  padding: var(--sp-4) var(--sp-5);
}

.member + .member {
  border-top: 1px solid var(--border);
}

.who {
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
  min-width: 0;
}

.name {
  color: var(--text);
  font-size: var(--fs-md);
  font-weight: 500;
  overflow-wrap: anywhere;
}

.you {
  color: var(--text-3);
  font-weight: 400;
}

.email {
  color: var(--text-3);
  font-size: var(--fs-sm);
  overflow-wrap: anywhere;
}

.role {
  padding: 1px var(--sp-3);
  border: var(--bw) solid var(--border-strong);
  border-radius: var(--radius);
  background: var(--surface-sunken);
  color: var(--text-2);
  font-size: var(--fs-xs);
  white-space: nowrap;
}

/* Место кнопки у тех, кого убрать нельзя: без него роль владельца прыгала бы
   вправо относительно остальных строк. */
.spacer {
  display: block;
  width: 0;
}

.empty {
  padding: var(--sp-5);
  color: var(--text-3);
  font-size: var(--fs-sm);
}

/* Отложенное приглашение — хорошая новость, а не ошибка: спокойная рамка. */
.pending {
  margin: 0;
  padding: var(--sp-4) var(--sp-5);
  border: var(--bw) solid var(--border-strong);
  border-radius: var(--radius-lg);
  background: var(--surface-2);
  color: var(--text-2);
  font-size: var(--fs-sm);
}

.error {
  margin: 0;
  padding: var(--sp-4) var(--sp-5);
  border: var(--bw) solid var(--error-border);
  border-radius: var(--radius-lg);
  background: var(--error-bg);
  color: var(--error);
  font-size: var(--fs-sm);
}

.invite {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}

.label {
  color: var(--text-2);
  font-size: var(--fs-sm);
  font-weight: 500;
}

.inviteRow {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: var(--sp-4);
  align-items: center;
}

/* ── Телефон (порог продублирован в ui/shell/useIsMobile.ts) ─────────────── */
@media (max-width: 720px) {
  .body {
    min-width: 0;
  }

  /* Три колонки в узкой строке превращаются в кашу: роль уезжает под имя. */
  .member {
    grid-template-columns: minmax(0, 1fr) auto;
  }

  .role {
    grid-column: 1;
    grid-row: 2;
    justify-self: start;
  }

  .inviteRow {
    grid-template-columns: 1fr;
  }
}
